// REPORTING TYPE
export const GET_REPORTING_TYPES = '/reporting_type/query';
export const GET_REPORTING_TYPE = '/reporting_type/';
export const POST_REPORTING_TYPE = '/reporting_type/';
export const PUT_REPORTING_TYPE = '/reporting_type/';
export const DELETE_REPORTING_TYPE = '/reporting_type/';
export const CHECK_REPORTING_TYPE_EXISTS = '/reporting_type/query';
